// src/index.js
// ============================================================================
// Entry point
// ============================================================================
// Deliberately minimal. Sentry, the service worker and the legacy provider
// stack came from CompareMechanic; none were load-bearing for the RMS, so they
// were removed rather than carried forward. Add them back when there is a
// reason, not out of inheritance.
//
// i18next is back, and for a reason: the RMS is meant to serve operators in
// thirteen languages, two of them right-to-left. See src/rms/i18n/.
// ============================================================================

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initI18n } from "./rms/i18n";

const root = createRoot(document.getElementById("root"));

const render = () =>
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );

// Rendering after the catalogue resolves avoids a flash of raw keys on first
// paint. If it fails -- a catalogue that will not parse, say -- render anyway:
// an interface showing untranslated keys is recoverable, a blank page is not.
initI18n().then(render, (err) => {
  console.error("i18n failed to initialise; rendering untranslated.", err);
  render();
});
